import MapLayer from '../map-layer.enum';
import setIndustryNewsLayer from './industry-news-layer';

function addIndustryNewsLayer(layer: MapLayer | string, metadata?: {}) {
  return setIndustryNewsLayer(layer, metadata);
}

export default addIndustryNewsLayer;
